import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

/**
 * 获取开发环境Token
 
 * @returns {string} Bearer token
 */
export const getDevToken = () => {
  const customToken = sessionStorage.getItem('devToken');
  return customToken
    ? `Bearer ${customToken}`
    : `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc4MzQ5OTAwNDYzOSwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTA4MTIxIn0.Bg461_bFrWdTWbjDPPwCQ7Pho7PrA36MFFmDCrwvAdSw40BM5_5shURB9YRfPbPUkBwPnQ-q935KlThylV2Gbw`;
};

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
